import {makeAutoObservable} from "mobx";
import LanguageMessages from "../assets/languageMessages/LanguageMessages";
import englishMessages from "../assets/languageMessages/englishMessages";
import russianMessages from "../assets/languageMessages/russianMessages";
import germanMessages from "../assets/languageMessages/germanMessages";
import frenchMessages from "../assets/languageMessages/frenchMessages";

const LOCAL_STORAGE_LANGUAGE_KEY = 'pigini-excelsior-key'

export default class LanguageStore {
    currentLanguage: 'en' | 'ru' | 'fr' | 'ge' = 'en';
    currentLanguageMessages: LanguageMessages = englishMessages;

    constructor() {
        makeAutoObservable(this);
        const localStorageLanguage = localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY)
        if(
            localStorageLanguage && 
            localStorageLanguage === 'en' || 
            localStorageLanguage === 'ru' || 
            localStorageLanguage === 'ge' ||
            localStorageLanguage === 'fr'
        ){
            this.setCurrentLanguage(localStorageLanguage);
            console.log(window.location.hostname);
        } else {
            const domain = window.location.hostname;
            if(domain.endsWith('.ru')) this.setCurrentLanguage('ru')
            else if(navigator.language.includes('ru-') || navigator.language === 'ru') this.setCurrentLanguage('ru');
            else if(navigator.language.includes('de-') || navigator.language === 'de') this.setCurrentLanguage('ge');
            else if(navigator.language.includes('fr-') || navigator.language === 'fr') this.setCurrentLanguage('fr');
        }
    }
    setCurrentLanguage = (language: 'en' | 'ru' | 'fr' | 'ge') => {
        this.currentLanguage = language;
        localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, language);
        switch (language) {
            case "en": this.setCurrentLanguageMessages(englishMessages); break;
            case "ru": this.setCurrentLanguageMessages(russianMessages); break;
            case "fr": this.setCurrentLanguageMessages(frenchMessages); break;
            case "ge": this.setCurrentLanguageMessages(germanMessages); break;
        }
    }
    setCurrentLanguageMessages = (languageMessages: LanguageMessages) => this.currentLanguageMessages = languageMessages;
}